define([
    "dojo/_base/declare",
    "csi/table/ToolbarPluginChart"
], function(declare,ToolbarPluginChart) {

    return declare(ToolbarPluginChart, {
    	bUseParentForName: true,
    	
        _getClassForName: function() {
            // summary: return the reflection class to be used for axis names
            var rc = this.inherited(arguments);
            // TA25880: Enhance Charting on Plan Views to Understand the Merchandising Attributes and Version (5.2.1 SP2)
            // S9787: [Continued] Merchandising 5.3 Refinement
            // If the node type is derived from MerchVersion, use the parent MerchLevel for a type name
            if (rc.isDerivedFrom("MerchVersion"))
                rc = rc.getParentClass();
            return rc;
        }
    });
});